import { _routes } from "SuperAdmin/Routes/routes";
import { Layout } from "antd";
import { Route, Routes } from "react-router-dom";
import Breadcrumb from "./Components/Breadcrumb/Breadcrumb";
const { Content } = Layout;
const ContentAdmin = () => {
  return (
    <Content
      style={{
        height: "100%",
        margin: "24px 16px",
      }}
    >
      <Breadcrumb />
      <Routes>
        {_routes.map((route, index) => {
          return (
            <Route
              path={route.path}
              exact
              element={<route.component />}
              key={index}
            />
          );
        })}
      </Routes>
    </Content>
  );
};

export default ContentAdmin;
